module.exports = __webpack_public_path__ + "img/store-receipts.6832fe31.svg";